/** Hell/Dunkel (design.md §2): Standard folgt dem System, umschaltbar im Kontomenü. */
export type ThemeChoice = 'system' | 'light' | 'dark';
const KEY = 'cc-theme';

export function getTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', choice);
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // privates Fenster o. Ä.: gilt nur für diese Sitzung
  }
}
